export default __webpack_public_path__ + "static/media/plain-sticker-g.357f6df8.png";